<script>

import Topbar from '@components/newtopbar'
import Footer from '@components/newfooter'


export default {
  components: { Topbar, Footer },
  created: () => {
    document.body.classList.add('authentication-bg')
    document.body.classList.add('authentication-bg-pattern')
    document.body.setAttribute('data-layout', 'topnav')
    document.body.classList.remove('right-bar-enabled')
    document.body.classList.remove('left-side-menu-condensed')
    document.body.classList.remove('boxed-layout')	
  },
}
</script>

<template>
	<div>
		<Topbar />
		<div class="content-page">
			<div class="content">
				<div class="container-fluid">
				<!--<div class="">-->
					<slot />
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<style lang="scss">

	body {
		background-color: #f1f1f1;
	}

	menu,ol,ul {
		list-style: none;
		padding:0;
	}
	
	.card-header.custom {	
    background: #fff;
	border: 1px solid #ebebeb;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	padding: 3px;
    position: relative;
    overflow: hidden;
    color: #333;
    background-size: 40px;
    background-image: -webkit-linear-gradient(0,transparent 50%,#000 50%);
    background-image: -moz-linear-gradient(0 50%,transparent 50%,rgba(255,255,255,.5) 50%);
    background-image: -ms-linear-gradient(0,transparent 50%,rgba(255,255,255,.5) 50%);
    background-image: -o-linear-gradient(0,transparent 50%,rgba(255,255,255,.5) 50%);
	
    }	
</style>
